import { QueryClientProvider } from "@tanstack/react-query";
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./i18n";
import {
  ensureApplicationIdPersisted,
  initApplicationId,
  persistNativeApplicationId,
} from "./lib/applicationId";
import { bootstrapLanguage } from "./lib/language";
import { queryClient } from "./lib/queryClient";
import { initSentry } from "./lib/sentry/instrument";
import { bootstrapTheme } from "./lib/theme";
import { routeTree } from "./routeTree.gen";
import "./index.css";

// 初回ペイントから正しいテーマカラーで描画するため、render 前に localStorage の
// application_id を確定させてからテーマを :root に書き込む（Utage-Web 運用と同じ）。
if (typeof window !== "undefined") {
  persistNativeApplicationId(new URLSearchParams(window.location.search));
  ensureApplicationIdPersisted();
}
bootstrapTheme();

const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: "intent",
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
});

initSentry(router);

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element #root not found");
}

await initApplicationId(new URLSearchParams(window.location.search));
await bootstrapLanguage();

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
    </QueryClientProvider>
  </StrictMode>,
);
